import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {InvSearchParamType} from "../../pages/inventory/inv/list/interface";
import {InvDetailHistorySearchParamType} from "../../pages/inventory/inv/detail/interface";
import {InvCreateType} from "../../pages/inventory/inv/create/interface";

const url = "api/inventory/base/";

export async function readInv(param: InvSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_inventory", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportInvExcel(param: InvSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_inventory_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}

export async function deleteInv(data: { inventoryIdList: number[] }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_inventory", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readInvDetail(data: number): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_inventory_detail", {inventoryId: data});
    } catch (err: any) {
        return err?.response;
    }
}

export async function readPresentInvAmount(data: number): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_present_inventory_amount", {inventoryId: data});
    } catch (err: any) {
        return err?.response;
    }
}

export async function readPresentInvDetailHistory(data: InvDetailHistorySearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_present_inventory_detail_history", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function deleteInvSingle(data: { inventoryId: number }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_inventory_single", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function createInv(data: InvCreateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_inventory", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function createInvBarcode(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_inventory_barcode");
    } catch (err: any) {
        return err?.response;
    }
}

export async function readInventoryChangeDetail(data: number): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_inventory_change_detail", {inventoryChangeId: data});
    } catch (err: any) {
        return err?.response;
    }
}